<template>
  <div class="modal" :class="modalData.styleType.cls" id="modal-danger">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="close" aria-label="Close">
          <span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">{{$t(modalData.title)}}</h4>
        </div>
        <div class="modal-body">
          <div v-if="dataRow != null">
            <p v-if="dataRow.apartment_code != ''">
              {{$t(modalData.body)}} {{$t('common.delete_modal.invoice_code')}} : {{dataRow.invoice_number}}, {{$t('common.delete_modal.apartment_code')}} :  {{dataRow.apartment_code}}
            </p>
            <p v-else>
              {{$t(modalData.body)}} {{$t('common.delete_modal.invoice_code')}} : {{dataRow.invoice_number}}
            </p>
          </div>
          <div v-else class="row">
            <div class="col-md-12">
              <p>{{$t(modalBodyData)}}</p>
            </div>
            <div class="col-md-12" v-if="isShowComment">
              <label for="">{{ $t('common.notes') }}</label>
              <textarea name="" id="" cols="30" rows="4" class="form-control" v-model="commentData"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <template v-if="modalData.styleType.cls !== 'modal-default'">
            <button
              type="button"
              class="btn btn-outline pull-left"
              @click="close">
              {{$t(modalData.buttonNo)}}
            </button>
            <button
              type="button"
              class="btn btn-outline"
              @click="onConfirm">
              {{$t(modalData.buttonYes)}}
            </button>
          </template>
          <template v-else>
            <button
              type="button"
              :class="customStyle == 'customerStyle' ? 'btn btn-default pull-left custom-style' : 'btn btn-default pull-left'"
              @click="close">
              {{$t(modalData.buttonNo)}}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="onConfirm">
              {{$t(modalData.buttonYes)}}
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'lte-modal',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    dataRow: {},
    customStyle: {
      type: String,
      default() {
        return ''
      }
    },
    isShowComment: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      modalData: {
        title     : "common.delete_modal.title",
        body      : "common.delete_modal.content",
        buttonNo  : "common.delete_modal.btnNo",
        buttonYes : "common.delete_modal.btnYes",
        styleType : {
          cls   : "modal-danger",
          icon  : ""
        }
      },
      styleObject: {
        default : "modal-default",
        danger  : "modal-danger",
        info    : "modal-info",
        warning : "modal-warning",
        success : "modal-success"
      },
      iconObject: {
        danger  : "fa-ban",
        info    : "fa-info",
        warning : "fa-warning",
        success : "fa-check"
      },
      commentData: null
    }
  },
  computed: {
    modalBodyData() {
      return this.item.body
    }
  },
  methods: {
    onConfirm: function () {
      let data = {}
      if (this.isShowComment) {
        data['commentData'] = this.commentData
      }
      this.$emit('onConfirm', data)
      this.commentData = null
    },
    close: function() {
      var self = this;
      self.$emit('close')
      this.commentData = null
    },
    getStyle(style) {
      let cls = this.styleObject[style];
      return {
        cls: cls
      }
    },
  },
  mounted() {
    this.modalData.title      = this.item.title
    this.modalData.body       = this.item.body
    this.modalData.styleType  = this.getStyle(this.item.styleType)
    this.modalData.buttonNo   = this.item.buttonNo
    this.modalData.buttonYes  = this.item.buttonYes
  }
}

</script>

<style lang="scss" scoped>
  .modal {
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }
  .custom-style {
    background-color: #f29911;
    border-color: #f29911;
    color:#fff
  }
</style>



// WEBPACK FOOTER //
// src/components/LTEModal.vue